/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function Playhead(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'Playhead',
      'aria-hidden': true,
      focusable: false,
      width:  38 * scale,
      height: 18 * scale,
      viewBox: '0 0 38 18',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"d":"M1 17.5c-.2 0-.5-.1-.5-.5V1C.5.8.6.5 1 .5h27c.6 0 1.4.6 1.6.9l7 7c.6.6.1 1.1 0 1.3l-7 7c-.2.2-1 .9-1.6.9H1z","fill":"currentColor","stroke":"#2b2b2b","strokeWidth":"1"}))
}
